
/*
Import font awesome icons
*/
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faBarcode,
  faBars,
  faBell,
  faBookOpen,
  faChalkboardTeacher,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  faClock,
  faCog,
  faCogs,
  faCopy,
  faCut,
  faDiceD20,
  faDownload,
  faEdit,
  faEraser,
  faExternalLinkAlt,
  faEye,
  faFileMedical,
  faFilePdf,
  faFilePrescription,
  faFilter,
  faFolderPlus,
  faGlobe,
  faGraduationCap,
  faHammer,
  faHandHoldingMedical,
  faHeartbeat,
  faHospital,
  faHourglassEnd,
  faHourglassStart,
  faInfoCircle,
  faList,
  faLock,
  faMagic,
  faMedkit,
  faMinus,
  faNotesMedical,
  faPen,
  faPlus,
  faPrescription,
  faQuestion,
  faSearch,
  faSchool,
  faSignInAlt,
  faSignOutAlt,
  faStethoscope,
  faStickyNote,
  faStopwatch,
  faStopCircle,
  faSort,
  faSortUp,
  faSortDown,
  faTable,
  faTag,
  faThLarge,
  faTimes,
  faTimesCircle,
  faTrash,
  faUndo,
  faUnlock,
  faUpload,
  faUser,
  faUserGraduate,
  faUserClock,
  faUserFriends,
  faUserInjured
} from '@fortawesome/free-solid-svg-icons'
import { faFontAwesome, faCanadianMapleLeaf } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBookMedical } from '@fortawesome/free-solid-svg-icons/faBookMedical'

export default function (Vue) {
  library.add(
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faBars,
    faBarcode,
    faBell,
    faBookMedical,
    faBookOpen,
    faChalkboardTeacher,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronUp,
    faCircle,
    faClock,
    faCog,
    faCogs,
    faCopy,
    faCut,
    faDiceD20,
    faDownload,
    faEdit,
    faExternalLinkAlt,
    faEye,
    faFileMedical,
    faFilePrescription,
    faFilePdf,
    faFilter,
    faFolderPlus,
    faEraser,
    faGlobe,
    faGraduationCap,
    faHammer,
    faHandHoldingMedical,
    faHeartbeat,
    faHospital,
    faHourglassEnd,
    faHourglassStart,
    faInfoCircle,
    faList,
    faLock,
    faMagic,
    faSearch,
    faMedkit,
    faMinus,
    faNotesMedical,
    faPen,
    faPlus,
    faPrescription,
    faQuestion,
    faSchool,
    faSignInAlt,
    faSignOutAlt,
    faStethoscope,
    faStickyNote,
    faStopwatch,
    faStopCircle,
    faSort,
    faSortUp,
    faSortDown,
    faTable,
    faTag,
    faThLarge,
    faTimes,
    faTimesCircle,
    faTrash,
    faUndo,
    faUnlock,
    faUpload,
    faUser,
    faUserGraduate,
    faUserClock,
    faUserFriends,
    faUserInjured,
  )
  library.add(
    faFontAwesome,
    faCanadianMapleLeaf
  )
  // IN CODE sample usage is:
  // fas-icon(class="fa", icon="graduation-cap")
  Vue.component('fas-icon', FontAwesomeIcon)
}
